/* eslint-disable filename-export/match-default-export */
import React from 'react';
import propTypes from 'prop-types';

import { MrWithTooltip } from '@ion/components';

const TOOLTIP = {
  message: 'Select up to to 90 days',
};

function generateMinDate() {
  const date = new Date();
  date.setDate(date.getDate() - 90); // max 90 days ago
  return date;
}

function generateMaxDate() {
  return new Date();
}

function MrWithDataRetention({ Component, componentProps, className, testId = 'MrWithDataRetention' }) {
  const maxDate = generateMaxDate();
  const minDate = generateMinDate();
  const finalProps = {
    ...componentProps,
    minDate,
    maxDate,
  };

  return (
    <MrWithTooltip {...TOOLTIP} className={className} data-test-id={testId}>
      <Component {...finalProps} />
    </MrWithTooltip>
  );
}

MrWithDataRetention.propTypes = {
  Component: propTypes.func,
  componentProps: propTypes.object,
  className: propTypes.string,
  testId: propTypes.string,
};

export default MrWithDataRetention;
